module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921095649_T.d3f44dd0.jpg";